/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Note } from "@octopusdeploy/design-system-components";
import type { JavaKeystoreProperties } from "@octopusdeploy/legacy-action-properties";
import type { ActionProperties, ProjectResource } from "@octopusdeploy/octopus-server-client";
import { repository } from "~/clientInstance";
import type { ActionInputDefinition } from "~/components/ActionInputs/ActionInputs";
import { ActionInputs } from "~/components/ActionInputs/ActionInputs";
import type { ActionEditProps } from "~/components/Actions/pluginRegistry";
import { BaseComponent } from "~/components/BaseComponent/BaseComponent";
import { VariableLookupText } from "~/components/form/VariableLookupText";
export interface JavaKeystoreActionEditProps<T = ActionProperties> extends ActionEditProps<T> {
    keystoreFilenameMessage: JSX.Element;
}
export interface JavaKeystoreActionEditState {
    project: ProjectResource;
}
export default class JavaKeystoreComponent extends BaseComponent<JavaKeystoreActionEditProps<JavaKeystoreProperties>, JavaKeystoreActionEditState> {
    constructor(props: JavaKeystoreActionEditProps<JavaKeystoreProperties>) {
        super(props);
        this.state = {
            project: null!,
        };
    }
    async componentDidMount() {
        await this.props.doBusyTask(async () => {
            const project = await repository.Projects.get(this.props.projectId!);
            this.setState({
                project,
            });
        });
    }
    render() {
        const properties = this.props.properties;
        const javaSensitiveSelectorActionInputDefinition: ActionInputDefinition = [
            {
                type: "sensitive-value-selector",
                key: "sensitive-value-selector",
                propertyKey: "Java.Certificate.Password",
                label: "Private key password",
                helperText: (<Note>
                        You can set an optional password which will be assigned to the private key. If this field is left blank, the default password of <em>changeit</em> will be used.
                    </Note>),
            },
        ];
        const certificateSelectorActionInputDefinition: ActionInputDefinition = [
            {
                type: "certificate-selector",
                key: "certificate-selector",
                propertyKey: "Java.Certificate.Variable",
            },
        ];
        return (<div>
                <ActionInputs actionUIDefinition={certificateSelectorActionInputDefinition} dependencies={this.props.actionInputsDependencies}/>
                <VariableLookupText localNames={this.props.localNames} value={properties["Java.Certificate.KeystoreFilename"]} onChange={(x) => this.props.setProperties({ ["Java.Certificate.KeystoreFilename"]: x })} label="Keystore filename" error={this.props.getFieldError("Java.Certificate.KeystoreFilename")}/>
                <Note>{this.props.keystoreFilenameMessage}</Note>
                <ActionInputs actionUIDefinition={javaSensitiveSelectorActionInputDefinition} dependencies={this.props.actionInputsDependencies}/>
                <VariableLookupText localNames={this.props.localNames} value={properties["Java.Certificate.KeystoreAlias"]} onChange={(x) => this.props.setProperties({ ["Java.Certificate.KeystoreAlias"]: x })} label="Keystore alias"/>
                <Note>
                    The optional alias to assign the private key to. If left blank, the default alias of <em>Octopus</em> will be used
                </Note>
            </div>);
    }
    static displayName = "JavaKeystoreComponent";
}
